import React from "react";
import { motion } from "framer-motion";
import { MANIFESTO, ASSETS } from "../lib/content";

const Chapter = ({ c, i }) => (
  <motion.div
    initial={{ opacity: 0, y: 50 }}
    whileInView={{ opacity: 1, y: 0 }}
    viewport={{ once: true, margin: "-80px" }}
    transition={{ duration: 0.7, ease: [0.16, 1, 0.3, 1] }}
    data-testid={`manifesto-chapter-${c.n}`}
    className="grid grid-cols-12 gap-4 md:gap-8 py-10 md:py-14 border-t border-white/10 group"
  >
    <div className="col-span-12 md:col-span-3">
      <span className="font-display font-black text-6xl md:text-8xl text-stroke group-hover:[color:#E08C2D] group-hover:[-webkit-text-stroke:0] transition-all duration-300">
        {c.n}
      </span>
    </div>
    <h3 className="col-span-12 md:col-span-4 font-display font-extrabold uppercase tracking-tight text-cream text-2xl md:text-4xl self-center">
      {c.title}
    </h3>
    <p className="col-span-12 md:col-span-5 font-mono text-sm text-cream/75 leading-relaxed self-center">
      {c.body}
    </p>
  </motion.div>
);

export const Manifesto = () => (
  <section id="manifesto" data-testid="manifesto-section" className="relative py-24 md:py-36 px-5 md:px-10 overflow-hidden">
    <img src={ASSETS.beansScoop} alt="" className="absolute right-0 top-0 w-1/2 h-full object-cover opacity-10 pointer-events-none" />
    <div className="relative max-w-[1400px] mx-auto">
      <div className="mb-10 max-w-2xl">
        <p className="font-mono text-xs uppercase tracking-[0.3em] text-ember mb-4">The Manifesto</p>
        <h2 className="font-display font-black uppercase tracking-tight text-cream text-5xl md:text-7xl leading-[0.9]">
          Why air <span className="font-serif italic font-normal lowercase text-ember">beats</span> fire
        </h2>
      </div>
      <div>
        {MANIFESTO.map((c, i) => (
          <Chapter key={c.n} c={c} i={i} />
        ))}
      </div>
    </div>
  </section>
);
